module.exports = __webpack_public_path__ + "static/tree-485293a532b13cb41d56cfc5913ce250.jpg";